import axios from 'axios'
import store from '../store'
import { createStagedTimer, createAsyncTaskGroup } from './batchedRequest'
// import { Message } from 'element-ui'

// create an axios instance
const service = axios.create({
  /* eslint-disable */
  baseURL: store.state.apiServer,
  /* eslint-enable */
  timeout: 12000
})

// 分阶段计时器，可以是任意个
const time_ignore = 150 // 请求持续超过这个时间才显示 loading
const time_stage0 = 1000 // 第一阶段 loading 持续多久
const time_stage1 = 1000 // 第二阶段持续时间
const debounceDelay = 100 // 一组请求全部结束后，多长时间没有出现新的请求，则认为一组请求已经完成

let stopTimer
const requestTaskGroups = createAsyncTaskGroup({
  debounceDelay: debounceDelay,
  onStart () { // 开始一组请求
    stopTimer = createStagedTimer({
      times: [time_ignore, time_stage0, time_stage1],
      onStage () {
        store.commit('updateAppLoading', true)
      }
    })
  },
  onEnd () { // 一组请求完成
    store.commit('updateAppLoading', false)
    stopTimer()
    // 隐藏 loading
  }
})

// http request 拦截器
service.interceptors.request.use(
  config => {
    if (store.state.token) { // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.Authorization = `${store.state.token}`
    } else {
      const token = window.localStorage.getItem('hyy_www_token')
      if (token) {
        config.headers.Authorization = token
      }
    }
    requestTaskGroups.addTask()
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

service.interceptors.response.use(
  response => {
    requestTaskGroups.finishTask()
    if (response.data.state) {
      return response
    } else {
      if (response.data.code === 401) {
        console.log(401)
        // Message.error(response.data.message)
      } else {
        console.log(response.data)
        // Message.error(response.data.message)
      }
      return response
    }
  },
  error => {
    requestTaskGroups.finishTask()
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 返回 401 清除token信息并跳转到登录页面
          store.commit('LOG_OUT')
          if (process.env.NODE_ENV !== 'development') {
            window.location.href = '/index.html'
          }
      }
    }
    try {
      store.state.notify.title = error.response.data.message
      store.state.notify.timeout = 6000
      return Promise.reject(error.response.data.message) // 返回接口返回的错误信息
    } catch (error) {
      return error
    }
  }
)

export default service
